import { render, staticRenderFns } from "./AtomCheckboxPrimary.vue?vue&type=template&id=17fb7b74"
import script from "./AtomCheckboxPrimary.vue?vue&type=script&lang=js"
export * from "./AtomCheckboxPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports